import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;

export const api = axios.create({
  baseURL: `${BASE}/api`,
});

export function setAuthToken(token) {
  if (token) {
    api.defaults.headers.common.Authorization = `Bearer ${token}`;
    localStorage.setItem("sp_token", token);
  } else {
    delete api.defaults.headers.common.Authorization;
    localStorage.removeItem("sp_token");
  }
}

// Rehydrate on load
const existing = localStorage.getItem("sp_token");
if (existing) setAuthToken(existing);

export function formatApiError(e, fallback = "Something went wrong") {
  const detail = e?.response?.data?.detail;
  if (!detail) return fallback;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((d) => (d?.msg || JSON.stringify(d)).replace(/^Value error, /, "")).join(" ");
  return String(detail);
}
